/**
 * @generated SignedSource<<f943037c0f065f57bca4f1ea14be320f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PositionLevel = "casual" | "committee" | "executive" | "officer" | "subcommittee" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ShowPagePosition_position$data = {
  readonly assignees: {
    readonly " $fragmentSpreads": FragmentRefs<"Assignment_Assignees" | "Avatars_users">;
  } | null | undefined;
  readonly description: string | null | undefined;
  readonly fileTypes: {
    readonly " $fragmentSpreads": FragmentRefs<"Attachments_FileType">;
  } | null | undefined;
  readonly id: string;
  readonly level: PositionLevel | null | undefined;
  readonly link: string | null | undefined;
  readonly name: string | null | undefined;
  readonly tasks: {
    readonly __id: string;
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"Checklist_TaskConnection">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CommentFeed_comments">;
  readonly " $fragmentType": "ShowPagePosition_position";
};
export type ShowPagePosition_position$key = {
  readonly " $data"?: ShowPagePosition_position$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShowPagePosition_position">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShowPagePosition_position",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "assignees",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatars_users"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Assignment_Assignees"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CommentFeed_comments"
        }
      ],
      "type": "CommentableInterface",
      "abstractKey": "__isCommentableInterface"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SuggestedFileTypeConnection",
      "kind": "LinkedField",
      "name": "fileTypes",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Attachments_FileType"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "key": "date",
              "value": "asc"
            }
          ]
        }
      ],
      "concreteType": "TaskConnection",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Checklist_TaskConnection"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "tasks(order:[{\"key\":\"date\",\"value\":\"asc\"}])"
    }
  ],
  "type": "Position",
  "abstractKey": null
};

(node as any).hash = "9e71b9c7e9de394a671f9df996e4cb72";

export default node;
